import React from 'react';
import Sidebar from './Sidebar';

export default function AppLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#030508] text-white">
      <Sidebar />
      <div className="lg:pl-60 min-h-screen transition-all duration-200">
        {children}
      </div>
    </div>
  );
}
